import globalValues from '@/core/helpers/enums/globalValues';
import router from '@/core/router';
import AnswerService from '@/core/services/answer';
import CandidateService from '@/core/services/candidate';
import JourneyService from '@/core/services/journey';
import ReferralService from '@/core/services/referral';
import SubmissionService from '@/core/services/submission';
import { Module } from 'vuex';
import i18n from '../../i18n';

const journeyService = new JourneyService();
const candidateService = new CandidateService();
const answerService = new AnswerService();
const referralService = new ReferralService();
const submissionService = new SubmissionService();

const journeyModule: Module<any, any> = {
   state: {
      answers: [],
      candidate: null,
      candidateId: null,
      submission: null,
      candidateStep: null,
      choiceId: null,
      choiceImages: [],
      choicesToRemove: [],
      content: null,
      end: null,
      files: [],
      isBetweenStep: false,
      isSubmissionRedirect: false,
      isNextDisabled: false,
      moduleValidationErrors: {} as Record<string, boolean>,
      journey: null,
      journeyId: null,
      logo: null,
      moduleId: null,
      moduleImages: [],
      prevPage: 1,
      referral: null,
      start: null,
      stepId: null,
      time: null,
      timeNumber: 0,
      tenant: null,
      step_module_errors_by_id: {},
   },
   getters: {
      step_module_errors_by_id: (state) => (step_module_id: any) => {
         if (state.step_module_errors_by_id) return state.step_module_errors_by_id[step_module_id];
      },
      moduleImages: (state) => {
         return state.moduleImages;
      },
      choiceImages: (state) => {
         return state.choiceImages;
      },
      time: (state) => {
         return state.time;
      },
      timeNumber: (state) => {
         return state.timeNumber;
      },
      logo: (state) => {
         return state.logo;
      },
      isNextDisabled: (state) => {
         if (state.isNextDisabled) return true;
         return Object.values(state.moduleValidationErrors).some((hasError) => hasError);
      },
      isBetweenStep: (state) => {
         return state.isBetweenStep;
      },
      answers: (state) => {
         return state.answers;
      },
      prevPage: (state) => {
         return state.prevPage;
      },
      journey: (state) => {
         return state.journey;
      },
      candidate: (state) => {
         return state.candidate;
      },
      submission: (state) => {
         return state.submission;
      },
      candidateStep: (state) => {
         return state.candidateStep;
      },
      choicesToRemove: (state) => {
         return state.choicesToRemove;
      },
      tenant: (state) => {
         return state.tentant;
      },
   },
   mutations: {
      setLanguage(state, newValue) {
         i18n.global.locale.value = newValue.code;
      },
      setTime(state, newValue) {
         state.time =
            typeof newValue == 'string' || newValue == null ? newValue : String(new Date(newValue * 1000).toISOString().substr(11, 8));
         state.timeNumber = typeof newValue == 'string' ? null : newValue;
      },
      setLogo(state, newValue) {
         state.logo = newValue;
      },
      setNextButtonDisabled(state, newValue) {
         state.isNextDisabled = newValue;
      },
      setModuleValidationError(state, { moduleId, hasError }: { moduleId: string; hasError: boolean }) {
         state.moduleValidationErrors[moduleId] = hasError;
      },
      clearModuleValidationError(state, moduleId: string) {
         delete state.moduleValidationErrors[moduleId];
      },
      clearAllModuleValidationErrors(state) {
         state.moduleValidationErrors = {};
      },
      setIsBetweenStep(state, newValue) {
         state.isBetweenStep = newValue;
      },
      addFile(state, addFile) {
         addFile.submission_random = sessionStorage.getItem(globalValues.candidate.journeyRandom);
         var copy = state.files.find((file: any) => file.moduleId == addFile.moduleId);
         if (copy) {
            state.files[state.files.indexOf(copy)] = addFile;
         } else {
            state.files.push(addFile);
         }
      },
      setReferral(state, value) {
         state.referral = value;
      },
      setIsSubmissionRedirect(state, value) {
         state.isSubmissionRedirect = value;
      },
      resetAnswersAndPage(state, page) {
         state.answers = [];
         state.prevPage = page;
         state.choicesToRemove = [];
      },
      setAnswerDetails(state, answerDetails) {
         if (answerDetails.moduleId) {
            state.moduleId = answerDetails.moduleId;
         } else if (answerDetails.stepId) {
            state.stepId = answerDetails.stepId;
            state.start = answerDetails.start;
         } else if (answerDetails.journeyId) {
            state.candidateId = answerDetails.candidateId;
            ((state.journeyId = answerDetails.journeyId), (state.start = answerDetails.start));
         } else if (answerDetails.end) {
            state.end = answerDetails.end;
         }
      },
      addAnswer(state, answer) {
         answer.submission_random = sessionStorage.getItem(globalValues.candidate.journeyRandom);
         var copy = state.answers.find((answr: any) => answr.moduleId == answer.moduleId);
         if (copy) {
            state.answers[state.answers.indexOf(copy)] = answer;
         } else {
            state.answers.push(answer);
         }
      },
      addChoiceToRemove(state, newChoice) {
         var copy = state.choicesToRemove.find((choice: any) => choice.choiceId == newChoice.id);
         if (copy) {
            state.choicesToRemove[state.choicesToRemove.indexOf(copy)] = newChoice;
         } else {
            state.choicesToRemove.push(newChoice);
         }
      },
      setChoiceId(state, val) {
         state.choiceId = val;
      },
      setContent(state, val) {
         state.content = val;
      },
      setJourney(state, val) {
         state.journey = val;
      },
      SET_ANSWER_ERROR(state, { step_module_id, error_response }) {
         state.step_module_errors_by_id = { ...state.step_module_errors_by_id, [step_module_id]: error_response };
      },
   },
   actions: {
      async getReferralByJourneyAndReferralId(context, { journeyId, referralCode }) {
         return await referralService
            .getReferralByJourneyAndReferralId(journeyId, referralCode)
            .then((response: any) => {
               if (!response?.team?.tenant) {
                  return null;
               }
               context.state.tenant = response.team.tenant;
               sessionStorage.setItem(globalValues.tenant.name, response.team.tenant.name);
               return response;
            })
            .catch(() => null);
      },

      async getJourneyById(context, id) {
         return await journeyService
            .getJourneyById(id)
            .then((response: any) => {
               context.state.journey = response;
               context.state.journeyId = response.id;
               return response;
            })
            .catch((error) => {
               if (error?.response?.status == 410) {
                  return router.push({
                     name: 'Error',
                     query: {
                        error_title: 'error.journeyNotAvailable',
                        error_message: error.message || 'error.somethingWentWrong',
                        error_code: error.response.status,
                     },
                  });
               }
            });
      },

      async postSubmission(context, candidate) {
         if (candidate.addresses && candidate.addresses.length == 0) delete candidate.addresses;
         return await submissionService
            .postSubmission(candidate)
            .then((response: any) => {
               context.state.submission = typeof response == 'number' ? null : response;
               return response;
            })
            .catch((error) => {
               context
                  .dispatch('addNotification', {
                     notification: {
                        type: 'error',
                        message: error.message,
                     },
                  })
                  .then((response) => {
                     return response;
                  });
               throw error;
            });
      },

      async patchSubmission(context, { body }) {
         return await submissionService.patchSubmission(body).then((response: any) => {
            return response;
         });
      },

      async putSubmission(context, { body }) {
         return await submissionService.putSubmission(body).then((response: any) => {
            return response;
         });
      },

      async getCandidateStepById(context, id) {
         return await candidateService
            .getCandidateStepById(id)
            .then((response: any) => {
               context.state.candidateStep = response;
               return response;
            })
            .catch((error) => {
               return Promise.reject(error);
            });
      },

      async getSubmissionById(context, id) {
         return await candidateService.getSubmissionById(id).then((response: any) => {
            context.state.submission = {
               ...response,
               addresses: (response.addresses || []).map((a: any) => ({ ...a, type_key: a.type.key })),
            };
            return context.state.submission;
         });
      },

      async endStep(content, { id, end, state }) {
         var submission = [
            {
               op: 'replace',
               path: 'submission_state_id',
               value: state,
            },
            {
               op: 'replace',
               path: 'end',
               value: end,
            },
         ];

         await candidateService.patchSubmission(id, submission).then((response: any) => {
            return response;
         });
      },

      async postCandidateStep(context) {
         var candidateStep = {
            candidate_id: Number(sessionStorage.getItem(globalValues.candidate.id)),
            submission_id: Number(sessionStorage.getItem(globalValues.candidate.submissionId)),
            // time_used: null,
            step_id: context.state.stepId,
            start: context.state.start,
            attempt: 1,
            can_start: true,
            submission_random: sessionStorage.getItem(globalValues.candidate.journeyRandom),
         };

         return await candidateService.postCandidateStep(candidateStep).then((response: any) => {
            sessionStorage.setItem(globalValues.candidate.stepId, response.id);
            context.state.candidateStep = response;
            return response;
         });
      },

      async patchCandidateStep(content, { id, path, value }) {
         var candidateStep = [
            {
               op: 'replace',
               path: path,
               value: value,
            },
         ];
         const submission_random = sessionStorage.getItem(globalValues.candidate.journeyRandom);
         return await candidateService.patchCandidateStep(id, candidateStep, submission_random!).then((response: any) => {
            return response;
         });
      },

      async getCandidateNextStep(context, id) {
         return await candidateService.getSubmissionNextStep(id).then((response) => {
            return response;
         });
      },

      async getCandidateAttributes(context, { stepId, moduleId }) {
         return await candidateService.getCandidateAttributes(stepId, moduleId).then((response) => {
            return response;
         });
      },

      async postAnswerById(context, addAnswer) {
         var answer: any;
         if (!Array.isArray(addAnswer.choices)) {
            // Check if there's a file to upload
            if (addAnswer.media) {
               const formData = new FormData();
               formData.append('module_id', addAnswer.moduleId);
               formData.append('candidate_step_id', sessionStorage.getItem(globalValues.candidate.stepId) || '');
               if (addAnswer.content) formData.append('content', addAnswer.content);
               formData.append('submission_random', sessionStorage.getItem(globalValues.candidate.journeyRandom) || '');
               if (addAnswer.choiceId) formData.append('choice_id', addAnswer.choiceId);
               formData.append('media', addAnswer.media);
               if (addAnswer.type) formData.append('type', addAnswer.type);

               return await answerService
                  .postAnswer(formData)
                  .then((response: any) => {
                     return response;
                  })
                  .catch((error) => {
                     context.commit('SET_ANSWER_ERROR', { step_module_id: addAnswer.moduleId, error_response: error });

                     context.dispatch(
                        'addNotification',
                        {
                           notification: {
                              type: 'error',
                              message: error.message,
                           },
                        },
                        { root: true },
                     );
                     throw error;
                  });
            }

            answer = null;
            answer = {
               module_id: addAnswer.moduleId,
               candidate_step_id: Number(sessionStorage.getItem(globalValues.candidate.stepId)),
               content: addAnswer.content ? addAnswer.content : null,
               submission_random: sessionStorage.getItem(globalValues.candidate.journeyRandom),
               choice_id: addAnswer.choiceId ? addAnswer.choiceId : null,
            };

            return await answerService
               .postAnswer(answer)
               .then(async (response: any) => {
                  return response;
               })
               .catch((error) => {
                  context.commit('SET_ANSWER_ERROR', { step_module_id: addAnswer.moduleId, error_response: error });

                  context.dispatch(
                     'addNotification',
                     {
                        notification: {
                           type: 'error',
                           message: error.message,
                        },
                     },
                     { root: true },
                  );
                  throw error;
               });
         } else {
            return await answerService
               .postAnswers(addAnswer)
               .then(async (response: any) => {
                  return response;
               })
               .catch((error) => {
                  context.dispatch(
                     'addNotification',
                     {
                        notification: {
                           type: 'error',
                           message: error.message,
                        },
                     },
                     { root: true },
                  );
                  throw error;
               });
         }
      },
      async postBulkAnswers(context, formData: FormData) {
         return await answerService
            .postBulkAnswers(formData)
            .then((response: any) => {
               return response;
            })
            .catch((error) => {
               context.dispatch(
                  'addNotification',
                  {
                     notification: {
                        type: 'error',
                        message: error.message,
                     },
                  },
                  { root: true },
               );
               throw error;
            });
      },
      async patchAnswer(context, { id, body, submission_random }) {
         return await answerService
            .patchAnswer(id, body, submission_random)
            .then((response: any) => {
               return response;
            })
            .catch((error) => {
               context.dispatch(
                  'addNotification',
                  {
                     notification: {
                        type: 'error',
                        message: error.message,
                     },
                  },
                  { root: true },
               );
               throw error;
            });
      },
      async postSubmissionOccurence(context, { submissionId, submissionRandom, comment, submissionStateKey }) {
         return await candidateService
            .postSubmissionOccurence(submissionId, submissionRandom, comment, submissionStateKey)
            .then((response) => {
               return response;
            });
      },

      async deleteAnswer(context, { id, submission_random }) {
         return await answerService.deleteAnswer(id, submission_random).then((response: any) => {
            return response;
         });
      },
   },
};

export default journeyModule;

